import React from 'react';
import moment from 'moment-timezone';
import VersionTaskErrors from './input';

const maxValidationErrors = 50;
const dateRender = date => (date ? moment(date)
  .format('DD-MM-YYYY HH:mm') : 'N/A');
const validationErrorRenderer = errors => (errors.length === maxValidationErrors ? `${errors.length}+` : errors.length);
const config = {
  // List Table
  list: {
    // Table Columns
    showInlineDelete: false,
    showInlineEdit: false,
    commands: {
      showAdd: false,
      showDelete: false,
      showRefresh: true
    },
    sorter: {
      field: 'triggered_on',
      order: 'descend'
    },
    columns: [
      {
        title: 'Request User',
        dataIndex: 'request_user',
        key: 'request_user',
        width: '120px',
        align: 'left'
      },
      {
        title: 'Status',
        dataIndex: 'status',
        width: '120px',
        align: 'left'
      },
      {
        title: 'Start boundary',
        dataIndex: 'boundary_start',
        key: 'boundary_start',
        align: 'left',
        render: (text, record) => dateRender(record.boundary_start)
      },
      {
        title: 'End boundary',
        dataIndex: 'boundary_end',
        key: 'boundary_end',
        align: 'left',
        render: (text, record) => dateRender(record.boundary_end)
      },
      {
        title: 'Run on',
        dataIndex: 'completed_on',
        key: 'completed_on',
        align: 'left',
        render: (text, record) => dateRender(record.completed_on)
      },
      {
        title: '# Errors',
        dataIndex: 'validation_errors',
        key: 'validation_errors',
        align: 'center',
        render: (text, record) => validationErrorRenderer(record.validation_errors)
      }
    ],
    // General
    title: 'Validation Tasks'
  },
  // Detail Screen
  detail: {
    // General
    title: 'Roster Version',
    component: props => (
      <VersionTaskErrors
        {...props}
        title="Roster Version"
      />
    )
  }
};

export default config;
